import type { FieldError } from 'react-hook-form';

type GetVisibleFieldErrorMessageOptions = {
  error?: FieldError;
  hiddenErrorTypes?: readonly string[];
};

export const getVisibleFieldErrorMessage = ({
  error,
  hiddenErrorTypes = [],
}: GetVisibleFieldErrorMessageOptions) => {
  if (!error) {
    return undefined;
  }

  if (hiddenErrorTypes.includes(error.type)) {
    return undefined;
  }

  return error.message;
};

export const hasVisibleFieldError = (options: GetVisibleFieldErrorMessageOptions) =>
  Boolean(getVisibleFieldErrorMessage(options));
